import { render } from "./CheckoutPromo.vue?vue&type=template&id=6b8fc31f"
import script from "./CheckoutPromo.vue?vue&type=script&lang=js"
export * from "./CheckoutPromo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__